/**
 * Utility functions for handling multilingual character names
 */

export interface MultilingualCharacterName {
  en: string;
  pt: string;
  es: string;
  fr: string;
  dk: string;
}

/**
 * Get the localized character name based on the current language
 */
export function getLocalizedCharacterName(
  characterName: string | MultilingualCharacterName | undefined,
  selectedLanguage?: string
): string {
  if (!characterName) {
    return 'Character';
  }

  if (typeof characterName === 'string') {
    return characterName;
  }

  if (typeof characterName === 'object') {
    let langCode = selectedLanguage
      ? selectedLanguage.split('-')[0]
      : (localStorage.getItem('selectedLanguage') || 'en').split('-')[0];
    
    if (langCode === 'da') langCode = 'dk';

    return (characterName as any)[langCode] || characterName.en || 'Character';
  }

  return 'Character';
}

/**
 * Check if character name is a multilingual object
 */
export function isMultilingualName(
  characterName: string | MultilingualCharacterName | undefined
): characterName is MultilingualCharacterName {
  return typeof characterName === 'object' && characterName !== null;
}
